module.exports = {
  version: '1.08'
};
